/**
 * Адреса картинок в CDN.
 *
 * Сервисы хранят и отдают имя файла в бакете, а не ссылку: хост у каждого
 * окружения свой, и зашитый в данные адрес переехал бы вместе с ними на
 * соседний стенд. Собирает ссылку тот, кто картинку показывает.
 */

/**
 * Хост CDN. По умолчанию dev — как и у адреса API: боевую сборку CI собирает
 * с явным значением, а локальной разработке отдельный бакет не нужен.
 */
const CDN_HOST = (import.meta.env.VITE_CDN_HOST || 'https://cdn.vpit.dev').replace(/\/+$/, '')

/**
 * Ссылка на файл в CDN по его имени в бакете. Пустое имя — пустая ссылка:
 * аватар без фото так и остаётся кружком с инициалами.
 */
export const cdnUrl = (name: string | undefined | null): string =>
  name ? `${CDN_HOST}/${name.replace(/^\/+/, '')}` : ''
